// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import * as mixins from '@helpcenter/styles/src/mixins';
import { FOOTER_HEIGHT } from 'view/layout/footer/styled';
import { token } from '@atlaskit/tokens';

const topicContainerWidth = '70%';
const topicContainerMinHeight = `calc(100vh - ${FOOTER_HEIGHT}px)`;
const helpObjectContainerWidth = '30%';
// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const Container = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	border-bottom: ${token('border.width', '1px')} solid ${token('color.border', '#EBECF0')};
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const TopicContainer = styled.div`
	width: ${topicContainerWidth};
	padding: ${token('space.400', '32px')} ${token('space.1000', '80px')};
	background-color: ${token('elevation.surface', '#FFFFFF')};
	border-right: ${token('border.width', '1px')} solid ${token('color.border', '#EBECF0')};
	box-sizing: border-box;
	min-height: ${topicContainerMinHeight};
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const HelpObjectContainer = styled.div`
	width: ${helpObjectContainerWidth};
	box-sizing: border-box;
	padding: ${token('space.150', '12px')} ${token('space.300', '24px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const SpinnerWrapper = styled.div`
	${mixins.flexCenter};
	margin-top: ${token('space.400', '32px')};
`;
